(function (window, document) {
  'use strict';

  var categories = ['preferences', 'analytics', 'marketing'];
  var pending = window.TopdonConsent && window.TopdonConsent.pending || [];
  var pendingChanges = window.TopdonConsent && window.TopdonConsent.pendingChanges || [];
  var callbacks = [];
  var changeCallbacks = [];
  var previous = null;
  var featureRequested = false;
  var consentmoListening = false;
  var reloading = false;
  var reloadOnRevoke = {};

  function consentmoApi() {
    var api = window.Consentmo;
    return api && typeof api.currentVisitorConsent === 'function' ? api : null;
  }

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function consentValue(value) {
    return value === true || value === 'yes' || value === 'granted';
  }

  function normalizeConsent(consent) {
    if (!consent) return null;

    var hasPreferences = Object.prototype.hasOwnProperty.call(consent, 'preferences') ||
      Object.prototype.hasOwnProperty.call(consent, 'functionality') ||
      Object.prototype.hasOwnProperty.call(consent, 'functional');
    if (!hasPreferences ||
      !Object.prototype.hasOwnProperty.call(consent, 'analytics') ||
      !Object.prototype.hasOwnProperty.call(consent, 'marketing')) return null;

    return {
      preferences: consentValue(
        typeof consent.preferences !== 'undefined' ? consent.preferences :
          (typeof consent.functionality !== 'undefined' ? consent.functionality : consent.functional)
      ),
      analytics: consentValue(consent.analytics),
      marketing: consentValue(consent.marketing)
    };
  }

  function readConsent() {
    var consentmo = consentmoApi();
    if (consentmo) {
      try {
        var consentmoConsent = normalizeConsent(consentmo.currentVisitorConsent());
        if (consentmoConsent) return consentmoConsent;
      } catch (error) {}
    }

    var api = privacyApi();
    if (!api || typeof api.currentVisitorConsent !== 'function') return null;

    try {
      return normalizeConsent(api.currentVisitorConsent());
    } catch (error) {
      return null;
    }
  }

  function allowed(requested) {
    var consent = readConsent();
    if (!consent) return false;

    return [].concat(requested).every(function (category) {
      return categories.indexOf(category) !== -1 && consent[category];
    });
  }

  function removePrefixed(storage, prefix) {
    for (var index = storage.length - 1; index >= 0; index--) {
      var key = storage.key(index);
      if (key && key.indexOf(prefix) === 0) storage.removeItem(key);
    }
  }

  function clearStorage(current, old) {
    if ((!old || old.preferences) && !current.preferences) {
      try {
        window.localStorage.removeItem('searches');
        removePrefixed(window.localStorage, 'nis:v1:');
      } catch (error) {}
      try {
        window.sessionStorage.removeItem('backToCollection');
      } catch (error) {}
      try {
        if (window.indexedDB) window.indexedDB.deleteDatabase('nis-blob-cache');
      } catch (error) {
        // Storage can be unavailable in private browsing or restricted contexts.
      }
    }
    if ((!old || old.analytics) && !current.analytics) {
      try {
        removePrefixed(window.localStorage, 'buy_button_click_');
      } catch (error) {}
    }
  }

  function refresh() {
    if (reloading) return;
    var current = readConsent();
    if (!current) return;

    var old = previous;
    var changed = !old || categories.some(function (category) {
      return old[category] !== current[category];
    });
    if (changed) {
      previous = current;
      changeCallbacks.forEach(function (callback) {
        try { callback(current, old); } catch (error) {
          if (window.console && window.console.error) window.console.error(error);
        }
      });
      if (!current.preferences) deactivateEmbeds();
      clearStorage(current, old);

      // Third-party SDKs that cannot be stopped require a fresh page on withdrawal.
      if (old && categories.some(function (category) {
        return old[category] && !current[category] && reloadOnRevoke[category];
      })) {
        reloading = true;
        window.location.reload();
        return;
      }
    }

    callbacks.forEach(function (entry) {
      if (!entry.done && entry.categories.every(function (category) {
        return current[category];
      })) {
        entry.done = true;
        entry.callback();
      }
    });
    if (current.preferences) activateEmbeds();
  }

  function whenAllowed(requested, callback) {
    var selected = [].concat(requested);
    if (typeof callback !== 'function' || !selected.length || selected.some(function (category) {
      return categories.indexOf(category) === -1;
    })) return;

    callbacks.push({ categories: selected, callback: callback, done: false });
    refresh();
  }

  function onChange(callback) {
    if (typeof callback !== 'function') return;
    changeCallbacks.push(callback);
    if (previous) callback(previous, null);
  }

  function requireReloadOnRevoke(requested) {
    [].concat(requested).forEach(function (category) {
      if (categories.indexOf(category) !== -1 && allowed(category)) {
        reloadOnRevoke[category] = true;
      }
    });
  }

  function loadScript(src, id, category) {
    if (category && !allowed(category)) return;
    if (id && document.getElementById(id)) {
      if (category) requireReloadOnRevoke(category);
      return;
    }
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (id) script.id = id;
    document.head.appendChild(script);
    if (category) requireReloadOnRevoke(category);
  }

  function track(event, data) {
    if (!allowed('analytics')) return;
    if (typeof window.gtag === 'function' && !window.gtag.__topdonNoop) {
      window.gtag('event', event, data);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: event, ecommerce: data });
    }
  }

  function activateEmbeds() {
    if (!allowed('preferences')) return;
    Array.prototype.forEach.call(document.querySelectorAll('iframe[data-consent-src]'), function (frame) {
      if (frame.getAttribute('src') !== frame.getAttribute('data-consent-src')) {
        frame.src = frame.getAttribute('data-consent-src');
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-consent-placeholder]'), function (placeholder) {
      placeholder.hidden = true;
    });
  }

  function deactivateEmbeds() {
    Array.prototype.forEach.call(document.querySelectorAll('iframe[data-consent-src]'), function (frame) {
      if (frame.getAttribute('src')) frame.src = 'about:blank';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-consent-placeholder]'), function (placeholder) {
      placeholder.hidden = false;
    });
  }

  function requestPrivacyApi() {
    var consentmo = consentmoApi();
    if (consentmo) {
      if (!consentmoListening && consentmo.events && consentmo.events.ConsentUpdate) {
        document.addEventListener(consentmo.events.ConsentUpdate, refresh);
        consentmoListening = true;
      }
      refresh();
      return;
    }

    if (privacyApi()) {
      refresh();
      return;
    }
    if (!featureRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      featureRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) {
          featureRequested = false;
        } else {
          refresh();
        }
      });
    }
  }

  window.TopdonConsent = {
    allowed: allowed,
    whenAllowed: whenAllowed,
    onChange: onChange,
    requireReloadOnRevoke: requireReloadOnRevoke,
    loadScript: loadScript,
    track: track
  };
  pendingChanges.forEach(onChange);
  pending.forEach(function (entry) {
    whenAllowed(entry[0], entry[1]);
  });

  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('shopify:section:load', activateEmbeds);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  // Also catches late Consentmo/Shopify initialization and missed consent events.
  window.setInterval(requestPrivacyApi, 1000);
  whenAllowed('preferences', function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', activateEmbeds, { once: true });
    } else {
      activateEmbeds();
    }
  });
  requestPrivacyApi();
})(window, document);
